export default (connection: string, event: string) => (
    `event:mercure-message:${connection}:${event}`
);

export type MercureMessageEventParameters<T> = {
    connectionName: string,
    eventName: string,
    data: T,
};
